import { CustomCellEditorProps } from "ag-grid-react";
import { Input, TreeSelect } from "antd";
import type { InputRef } from "antd";
import {
  UnitType,
  getTreeFromMeasuremntList
} from "pages/material-details/material-details-tab/units-tree";
import { useEffect, useMemo, useRef, useState } from "react";

type Props = CustomCellEditorProps & {
  dataMapVar: string;
  setKeyId: string;
  unitValueProp: string;
  unit: string;
  notFoundContent: any;
};

export function MeasurementSelectEditor(props: Props) {
  const {
    context,
    data,
    dataMapVar,
    notFoundContent,
    setKeyId,
    unitValueProp,
    unit,
    onValueChange
  } = props;
  const [unitId, setUnitId] = useState<string>();
  const [unitValue, setUnitValue] = useState<string>(data[unitValueProp] || "");
  const inputRef = useRef<InputRef>(null);
  const itemsMap = context[dataMapVar] as Array<UnitType>;

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const treeData = useMemo(() => {
    return getTreeFromMeasuremntList(itemsMap);
  }, [itemsMap]);

  const getValue = (uId = unitId, uValue = unitValue) => {
    const label = itemsMap.find((x) => x.id === uId);
    return {
      unitValue: {
        prop: unitValueProp,
        value: uValue === "" ? null : uValue
      },
      unitType: {
        prop: setKeyId,
        value: uId === undefined ? null : uId,
        name: unit
      },
      label: `${label?.unit ?? ""}`
    };
  };

  return (
    <div className="w-full !h-full flex items-center">
      <Input
        ref={inputRef}
        className="w-1/3 h-8"
        value={unitValue}
        onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
        onChange={(event: any) => {
          const uValue = event?.target?.value ?? null;
          setUnitValue(uValue);
          onValueChange(getValue(unitId, uValue));
        }}
        min="0"
      />
      <TreeSelect
        placeholder="Select"
        virtual={false}
        notFoundContent={notFoundContent}
        className="w-2/3 h-8"
        defaultValue={data[unit] || ""}
        value={unitId || undefined}
        onChange={(event: any) => {
          const uId = event;
          setUnitId(uId);
          onValueChange(getValue(uId, unitValue));
        }}
        styles={{ popup: { root: { maxHeight: 400, overflow: "auto" } } }}
        treeDefaultExpandAll
        treeData={treeData}
        allowClear
      />
    </div>
  );
}
